/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Handle, NodeResizer, Position } from '@xyflow/react'
import { Text, Box, Divider, Flex } from '@chakra-ui/react'
import { memo } from 'react'
import { MdDelete } from 'react-icons/md'

const CustomNode: React.FC<any> = ({
  id,
  data,
  selected,
  isConnectable
}: {
  id: string
  data: {
    label: string
    removido?: boolean
    aoExcluir?: (cargoId: string) => void
    niveisPontuados?: Array<{ nomeNivel: string, pontuacaoTotal: number }>
  }
  selected?: boolean
  isConnectable: boolean
}) => {
  const cor = data.removido ? 'var(--Red)' : 'var(--Azul)'
  // A alça continua montada porque a ligação precisa dela para ser desenhada.
  const conectavel = isConnectable && !data.removido
  const visibilidadeAlca = conectavel ? 'visible' : 'hidden'

  return (
    <Box
      bg="white"
      borderRadius="md"
      boxShadow="md"
      border={`2px solid ${cor}`}
      pos="relative"
      w="100%"
      h="100%"
      minW="350px"
      minH="100px"
      px="1rem"
      py="0.75rem"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <NodeResizer minWidth={350} minHeight={100} isVisible={selected} color={cor} />

      {data.removido && (
        <Flex
          className="nodrag nopan"
          pos="absolute"
          top="0.375rem"
          right="0.375rem"
          color="var(--Red)"
          cursor="pointer"
          title="Remover este cargo da trilha"
          _hover={{ color: 'var(--Red-hover)' }}
          onClick={() => data.aoExcluir?.(id)}
        >
          <MdDelete size={18} />
        </Flex>
      )}

      {/* Nome do cargo */}
      <Text
        fontSize="lg"
        fontWeight="bold"
        textAlign="center"
        color={cor}
        whiteSpace="normal"
        wordBreak="break-word"
        mb="0.5rem"
      >
        {data.label}
      </Text>

      <Divider borderColor={cor} mb="0.5rem" />

      <Flex
        wrap="wrap"
        align="center"
        justify="center"
        gap="0.5rem"
        w="100%"
        fontSize="sm"
        fontWeight="500"
        color="gray.700"
      >
        {data.niveisPontuados?.map((nivel, indice) => (
          <Flex key={indice} align="center">
            <Text whiteSpace="nowrap">
              {nivel.nomeNivel.replaceAll('_', ' ')}: {nivel.pontuacaoTotal}
            </Text>
            {indice < (data.niveisPontuados?.length ?? 0) - 1 && (
              <Text mx="0.5rem" color="gray.400" fontWeight="normal">|</Text>
            )}
          </Flex>
        ))}
      </Flex>

      <Handle type="target" position={Position.Top} isConnectable={conectavel} style={{ background: cor, visibility: visibilidadeAlca }} />
      <Handle type="source" position={Position.Bottom} isConnectable={conectavel} style={{ background: cor, visibility: visibilidadeAlca }} />
    </Box>
  )
}

export default memo(CustomNode)
